
import Input from "../../../common/input/Input";

export default function FieldDuration({ duration, onChange }) {
	return (
		<div className="flex flex-row items-center">
			<div className="flex-grow">
				<Input
					onChange={onChange}
					value={duration}
					label={"مدت جلسه"}
					placeholder={""}
				/>
			</div>
			<div className="spacer p-[3px]"></div>
			<div className="font-Vazir-400 text-[#444444]">دقیقه</div>
		</div>
	)
}
